export const GlobalVariables = {
    currencyId:1,
    countryId: 4,
    productGroupId:1,
    itemGroupId:1 //FG
}